import textPopup from '../views/textAngularPopup.html';
class ViewTeachingPlanController {
    // @ngInject
    constructor($scope, $rootScope, authService, localStorageService, $state, TPCONSTANT, $stateParams, $mdDialog, GOOGLE_CLASSROOM_CONSTANTS, Upload, CONSTANTS) {

        //To current teaching plan id
        let planId = $state.params.planId
        //To get current user id
        let userId = localStorageService.get('user_id')
        $scope.editTp = false
        let authoring = localStorageService.get("authoringData")
        this.$onInit = () => {
            $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false
            if (!$rootScope.isLoggedIn) {
                $state.go("login", {}, {
                    reload: true
                })
            }
            if (!authoring) {
                $state.go("authdashboard")
            } else {
                var reqObj = {
                    session_id: authoring.session_id,
                    curriculum_id: authoring.curriculum_id,
                    class_id: authoring.class_id,
                    batch_id: authoring.batch_id,
                    subject_id: authoring.subject_id,
                    school_id: authoring.school_id,
                    academic_year: authoring.academic_year,
                    user_id: userId
                }
                authService.callAPI(GOOGLE_CLASSROOM_CONSTANTS.API_GET_GOOGLE_CLASSROOM, 'POST', reqObj, function (response) {
                    if (response.result && response.result.data && response.result.data.details) {
                        try {
                            $scope.classroomDetails = response.result.data.details;
                        } catch (ex) {
                            console.log(ex);
                        }
                    }
                    _.defer(function () {
                        $scope.$apply();
                    });
                });
                $scope.getTeachingPlan(planId)
            }
        }
        //To get Roles and Privileges
        let tpPrivilege = _.filter(localStorageService.get("feature_privileges"), function (feature) {
            return feature.module_state == "teachingPlan"
        })
        $scope.tpUserPrivilege = {};
        if (tpPrivilege.length > 0) {
            _.each(tpPrivilege, function (tpObj) {
                let user_access = {};
                _.each(tpObj.privilege, function (privObj) {
                    user_access[privObj.name.toLowerCase()] = privObj.status
                })
                $scope.tpUserPrivilege[tpObj.feature_id] = user_access;
            })
        }
        //to check whether the user assigned for tp or not
        $scope.isUserAssigned = false;

        //to show or hide select role and user for approval process
        $scope.isSubmitApproval = false;

        //Status sent for approval
        $scope.isSentforApproval = false;

        //status (approve or reject)
        $scope.isStatusAdded = false;

        //approved
        $scope.isApproved = false;

        //created
        $scope.isCreated = false;



        //Boolean - To show complete button when the Teaching plan is approved
        $scope.isSetComplete = false

        //Boolean - To show Teaching plan completed status
        $scope.isCompleted = false
        $scope.isShowComplete = false

        //Boolean - To show uncompleted resources
        $scope.isShowApprovedResources = false

        //[Object] - Holds selected resource to submit for approval
        $scope.selectedResources = [];

        //[Object] - Holds selected resource to approve
        $scope.selectedResourcesforApproval = [];

        //Boolean - Current user is teaching plan creator or not
        $scope.isCreator = false;

        //Boolean -Current user is approver or not
        $scope.isApprover = false;

        $scope.isShowTpComplete = false
        //Get approver list
        let APPROVER_LIST_URL = TPCONSTANT.API_TP_APPROVERS



        // to get type of resource
        $scope.resourceTypes = TPCONSTANT.RESOURCES_LABEL

        //Get teachingplan
        //let GET_TP_URL = API_GET_TP
        $scope.approveMode = false

        let teachingPlanImgSize = 25
        let rightArrowIconSize = 10

        var setStatus = (status) => {
            switch (status) {
                case TPCONSTANT.STATUS_CREATED:
                    $scope.isSentforApproval = false;
                    $scope.isStatusAdded = false;
                    $scope.isApproved = false;
                    $scope.isCreated = true;
                    break;
                case TPCONSTANT.STATUS_SENT_FOR_APPROVAL:
                    $scope.isCreated = false;
                    $scope.isStatusAdded = false;
                    $scope.isApproved = false;
                    $scope.isSentforApproval = true;
                    break;
                case TPCONSTANT.STATUS_APPROVED:
                    $scope.isCreated = false;
                    $scope.isSentforApproval = false;
                    $scope.isStatusAdded = true;
                    $scope.isApproved = true;
                    $scope.preetyStatus = 'Teaching Plan Approved';
                    break;
                case TPCONSTANT.STATUS_REJECTED:
                    $scope.isCreated = false;
                    $scope.isSentforApproval = false;
                    $scope.isStatusAdded = true;
                    $scope.preetyStatus = 'Rejected';
                    $scope.isApproved = false
                    break;
            }
        }

        this.userId = userId
        localStorageService.set("viewMode", true);

        let plansSub = undefined;

        $scope.getTeachingPlan = (planId) => {
            authService.callAPI(TPCONSTANT.API_GET_TP + planId + "/" + userId, "GET", {}, function (response) {
                if (response && response.result && response.result.data) {
                    $scope.teachingPlan = response.result.data
                    if ($scope.teachingPlan && $scope.teachingPlan.teacher_id === userId)
                        $scope.isCreator = true;

                    let isStatusSet = false;
                    $scope.themeId = $scope.teachingPlan.theme_id

                    if ($scope.tpUserPrivilege.newTeachingPlan && $scope.tpUserPrivilege.newTeachingPlan.edit) {
                        isStatusSet = true;
                        $scope.editStatus = true
                    }
                    if ($scope.tpUserPrivilege.approveTeachingPlan && $scope.tpUserPrivilege.approveTeachingPlan.create) {
                        $scope.approveMode = true;
                        isStatusSet = true;
                    }
                    if (!isStatusSet) {
                        $scope.isStudent = true
                    }

                    //to check whether the tp has assigned users
                    if ($scope.teachingPlan && $scope.teachingPlan.assign_users && $scope.teachingPlan.assign_users.list && $scope.teachingPlan.assign_users.list.length > 0) {
                        $scope.isUserAssigned = true;
                    }


                    /***************** For send for Approval : START *************/

                    let isCurrentApprover = false;
                    let academics = {
                        session_id: authoring.session_id,
                        curriculum_id: authoring.curriculum_id,
                        class_id: authoring.class_id,
                        batch_id: authoring.batch_id,
                        subject_id: authoring.subject_id,
                        school_id: authoring.school_id
                    }
                    authService.callAPI(APPROVER_LIST_URL, "POST", academics, function (response) {
                        if (response.result && response.result.data && response.result.data.data) {
                            let resultData = response.result.data.data
                            if (resultData && resultData.length > 0 && resultData[0].roles)
                                $scope.approverRoles = resultData[0].roles
                            if ($scope.teachingPlan && $scope.teachingPlan.current_approver) {
                                $scope.approverRole = $scope.teachingPlan.current_approver.role;
                                $scope.filterPerson()
                                $scope.approverPerson = $scope.teachingPlan.current_approver._id;
                                isCurrentApprover = true;
                                if ($scope.teachingPlan.status !== TPCONSTANT.STATUS_SENT_FOR_APPROVAL)
                                    $scope.isApprover = false
                            }
                            $scope.$apply()
                        } else { }
                    })


                    /*if ($scope.teachingPlan && $scope.teachingPlan.status === "approved") {
                        if ($scope.teachingPlan.isComplete === false) {
                            $scope.isShowComplete = true
                        }
                        if ($scope.teachingPlan.isComplete === true) {
                            $scope.isCompleted = true
                            $scope.isShowComplete = false
                        }
                    }*/

                    //To get content added resources for send for approval
                    $scope.contentCreatedResources = [];
                    $scope.contentCreatedResourceIds = [];
                    if ($scope.teachingPlan && $scope.teachingPlan.resources && $scope.teachingPlan.resources.length > 0) {
                        _.each($scope.teachingPlan.resources, function (resource) {
                            if (resource.status) {
                                if (resource.status === 'created' || resource.status === 'sent_for_approval') {
                                    $scope.contentCreatedResources.push(resource)
                                    $scope.contentCreatedResourceIds.push(resource._id);
                                    if (isCurrentApprover) {
                                        if (resource.current_approver) {
                                            if (resource.current_approver._id === $scopeteachingPlan.current_approver._id)
                                                $scope.selectedResources.push(resource._id)
                                        }
                                    }
                                }
                            }
                        })
                    }
                    /********** For Approval : START *****************/
                    if ($scope.approveMode) {
                        //[Object] - details of resources to approve
                        $scope.approveResources = [];

                        //[String] - Ids of resources to approve
                        $scope.approveResourcesIds = [];

                        //whether to approve this teaching plan or not
                        $scope.isTeachingPlantoApporve = false
                        if ($scope.teachingPlan.current_approver) {
                            if ($scope.teachingPlan.status === 'sent_for_approval' && $scope.teachingPlan.current_approver._id === userId) {
                                $scope.isTeachingPlantoApporve = true
                                $scope.isApprover = true
                            }
                        }
                        _.each($scope.teachingPlan.resources, function (resource) {
                            if (resource.current_approver) {
                                if (resource.status === 'sent_for_approval' && resource.current_approver._id === userId) {
                                    $scope.isResourceAccess = true
                                    $scope.approveResources.push(resource)
                                    $scope.approveResourcesIds.push(resource._id)
                                    $scope.isApprover = true
                                }
                            }
                        })
                    }
                    /********** For Approval : END *****************/

                    /********** For Approval : START *****************/
                    if ($scope.teachingPlan.students && $scope.teachingPlan.students.length > 0) {
                        if ($scope.teachingPlan.status === TPCONSTANT.STATUS_APPROVED && $scope.teachingPlan.isComplete === false) {
                            $scope.isSetComplete = true
                            $scope.isShowComplete = false
                            $scope.isCompleted = false
                            $scope.isShowApprovedResources = false
                        } else if ($scope.teachingPlan.status === TPCONSTANT.STATUS_APPROVED && $scope.teachingPlan.isComplete === true) {
                            $scope.isCompleted = true
                            $scope.isSetComplete = false
                            $scope.isShowApprovedResources = false
                            $scope.isShowComplete = false
                        }
                    }
                    $scope.approvedResources = [];
                    $scope.approvedResourcesIds = [];
                    $scope.completedResources = []
                    if ($scope.teachingPlan && $scope.teachingPlan.resources.length > 0) {
                        _.each($scope.teachingPlan.resources, function (resource) {
                            if (resource.status) {
                                if ((resource.status === 'approved' || resource.status === 'conducted' || resource.status === 'published') && resource.isComplete === false) {
                                    $scope.approvedResources.push(resource)
                                    $scope.approvedResourcesIds.push(resource._id)
                                } else if (resource.status === 'approved' && resource.isComplete === true)
                                    $scope.completedResources.push(resource)
                            }
                            if ($scope.teachingPlan.resources.length === $scope.completedResources.length) {
                                $scope.isShowComplete = true
                            }

                        })
                    } else if ($scope.teachingPlan && $scope.teachingPlan.status === "approved") {
                        if ($scope.teachingPlan.resources.length === 0 && $scope.teachingPlan.isComplete === false) {
                            $scope.isShowTpComplete = true
                        } else {
                            $scope.isShowComplete = true
                        }
                    }
                    /********** For Approval : END *****************/
                    setStatus($scope.teachingPlan.status)
                    _.defer(function () {
                        $scope.$apply();
                    });
                }
            })
        }

        this.$onDestroy = () => {

        }
        //To show user assign screen
        $scope.showAssignUser = () => {
            if ($scope.isUserAssigned) {
                var confirm = $mdDialog.confirm()
                    .textContent('It will reassign previously assigned students')
                    .ok('Ok')
                    .cancel('Cancel');
                $mdDialog.show(confirm).then(function () {
                    $state.go('assignUsers', {
                        planId: $state.params.planId,
                        previousState: {
                            state: $state.current.name,
                            params: {
                                'planId': $state.params.planId,
                                resourceId: $state.params.resourceId
                            }
                        }
                    })
                }, function () { });
            } else {
                $state.go('assignUsers', {
                    planId: $state.params.planId,
                    previousState: {
                        state: $state.current.name,
                        params: {
                            'planId': $state.params.planId,
                            resourceId: $state.params.resourceId
                        }
                    }
                })
            }
        }


        $scope.filterPerson = () => {
            // let approverList = _.filter($scope.approverRoles, function (person) {
            //     return person._id.indexOf($scope.approverRole) !== -1;
            // })
            let approverList = _.filter($scope.approverRoles, function(person) {
                return person._id == $scope.approverRole
           })
            if (approverList && approverList.length > 0)
                $scope.approverRolePersons = approverList[0].users
        }

        function convertFileToDataURLviaFileReader(url, callback) {
            var xhr = new XMLHttpRequest();
            xhr.onload = function () {
                var reader = new FileReader();
                reader.onloadend = function () {
                    callback(reader.result);
                }
                reader.readAsDataURL(xhr.response);
            };
            xhr.open('GET', url);
            xhr.responseType = 'blob';
            xhr.send();
        };

        let teachingPlanImg = 'teaching_plan.png'
        let rightArrow = 'ibt/arrow_right.png'
        convertFileToDataURLviaFileReader(teachingPlanImg, function (base64Image) {
            $scope.teachingPlanImg = base64Image;
        })
        convertFileToDataURLviaFileReader(rightArrow, function (base64Image) {
            $scope.rightArrow = base64Image;
        })

        $scope.gotoSite = (site) => {
            if (site.indexOf("http") === -1) {
                site = "http://" + site
            }
            window.open(site, "_blank")
        }

        // go to teaching plan edit mode with plan id and theme id
        $scope.gotoEdit = () => {
            console.log($scope.themeId)
            console.log(planId)
            $state.go('newTeachingPlan', {
                "id": $scope.themeId,
                "planId": planId
            });
        }

        // goto wizard page when click on next
        $scope.viewWizard = () => {
            $state.go('wizard', {
                "planId": planId
            })
        }



        //to show dropdown for selecting role and user for approval process
        $scope.submitforApprovalClick = () => {
            $scope.isSubmitApproval = true
        }

        $scope.submitforApproval = () => {
            if (!$scope.approverRole) {
                $scope.approverRoleError = "Select a role"
            }
            if (!$scope.approverPerson) {
                $scope.approverPersonError = "Select a person"
            }
            if ($scope.approverRole && $scope.approverPerson) {
                let approverId = $scope.approverPerson;
                let resIds = [];
                if ($scope.selectedResources.length > 0)
                    resIds = $scope.selectedResources;
                $scope.isSubmitApproval = false;
                let academics = {
                    session_id: authoring.session_id,
                    curriculum_id: authoring.curriculum_id,
                    class_id: authoring.class_id,
                    batch_id: authoring.batch_id,
                    subject_id: authoring.subject_id,
                    school_id: authoring.school_id,
                    class: authoring.class,
                    batch: authoring.batch,
                    session: authoring.session,
                    subject: authoring.subject,
                    curriculum: authoring.curriculum,
                    academic_year: authoring.academic_year,
                    tp_id: planId,
                    res_ids: resIds,
                    user_id: userId,
                    approver_id: approverId,
                    approver_role: $scope.approverRole,
                    is_tp_approval: true
                }
                authService.callAPI(TPCONSTANT.API_SEND_FOR_APPROVAL, "POST", academics, function (response) {
                    if (response.result) {
                        toastr.success("Successfully send for approval")
                        setStatus(TPCONSTANT.STATUS_SENT_FOR_APPROVAL)
                        console.log(response)
                    } else {
                        console.log(response.error)
                    }
                })
            }
        }

        $scope.setCompleteStatus = function () {

            $scope.isSetComplete = false
            $scope.isShowApprovedResources = false
            $scope.isShowComplete = false
            $scope.isShowTpComplete = false
            $scope.isSubmitApproval = false;
            let resIds = [];
            if ($scope.selectedApprovedResources)
                resIds = $scope.selectedApprovedResources
            let palnObj = {
                plan_id: planId,
                res_ids: resIds,
                user_id: userId
            }
            authService.callAPI(TPCONSTANT.API_COMPLETE_TP, "POST", palnObj, function (response) {
                if (response) {
                    $scope.isCompleted = true
                    $scope.isSetComplete = false
                    $scope.isShowApprovedResources = false
                    $scope.isShowComplete = false
                    $scope.isShowTpComplete = false

                    toastr.success("Updated complete status")
                    $scope.getTeachingPlan(planId)
                    $scope.$apply()
                } else {
                    toastr.error("Network Error, please try later.")
                }
            })

        }

        $scope.cancelApproval = () => {
            $scope.isSubmitApproval = false;
        }

        $scope.approve = (action) => {
            let tpData = {
                approver_id: userId,
                tp_status: "approved",
                tp_id: planId,
                is_tp_approval: $scope.isTeachingPlantoApporve,
                res_ids: $scope.selectedResourcesforApproval,
                session_id: authoring.session_id,
                curriculum_id: authoring.curriculum_id,
                class_id: authoring.class_id,
                batch_id: authoring.batch_id,
                subject_id: authoring.subject_id,
                school_id: authoring.school_id,
                class: authoring.class,
                batch: authoring.batch,
                session: authoring.session,
                subject: authoring.subject,
                curriculum: authoring.curriculum,
                academic_year: authoring.academic_year
            }
            authService.callAPI(TPCONSTANT.API_APPROVE_TP, "POST", tpData, function (response) {
                if (response.result) {
                    toastr.success("Teaching plan approved Successfully")
                    console.log(response)
                    setStatus(TPCONSTANT.STATUS_APPROVED)
                    $scope.getTeachingPlan(planId)
                    $scope.$apply()
                } else {
                    console.log(response.error)
                }
            })
        }
        $scope.reject = () => {
            let tpData = {
                approver_id: userId,
                tp_status: "rejected",
                tp_id: planId,
                is_tp_approval: $scope.isTeachingPlantoApporve,
                res_ids: $scope.selectedResourcesforApproval,
                session_id: authoring.session_id,
                curriculum_id: authoring.curriculum_id,
                class_id: authoring.class_id,
                batch_id: authoring.batch_id,
                subject_id: authoring.subject_id,
                school_id: authoring.school_id,
                class: authoring.class,
                batch: authoring.batch,
                session: authoring.session,
                subject: authoring.subject,
                curriculum: authoring.curriculum,
                academic_year: authoring.academic_year
            }
            authService.callAPI(TPCONSTANT.API_REJECT_TP, "POST", tpData, function (response) {
                if (response.result) {
                    toastr.success("Teaching plan rejected Successfully")
                    console.log(response)
                    setStatus(TPCONSTANT.STATUS_REJECTED)
                    $scope.getTeachingPlan(planId)
                    $scope.$apply()
                } else {
                    console.log(response.error)
                }
            })
        }

        $scope.showComplete = function () {
            $scope.isShowApprovedResources = true
            $scope.isShowComplete = true
            $scope.isSetComplete = false
        }

        $scope.selectAllStudent = {
            check: false
        }

        /*
         * Function to select all resources to submit for approval
         * 
         * @return : null
         */
        $scope.selectAllResources = function (type) {
            if (type == "submit") {
                if ($scope.selectAllStudent.check)
                    $scope.selectedResources = $scope.contentCreatedResourceIds
                else
                    $scope.selectedResources = [];
            } else if (type == "approve") {
                if ($scope.selectAllStudent.check)
                    $scope.selectedResourcesforApproval = $scope.approveResourcesIds
                else
                    $scope.selectedResourcesforApproval = [];
            } else if (type == "complete") {
                if ($scope.selectAllStudent.check)
                    $scope.selectedApprovedResources = $scope.approvedResourcesIds
                else
                    $scope.selectedApprovedResources = []
            }
        }

        $scope.changeResources = function (type) {
            if (type == "submit") {
                if ($scope.contentCreatedResourceIds.length !== $scope.selectedResources.length)
                    $scope.selectAllStudent.check = false;
                else
                    $scope.selectAllStudent.check = true;
            } else if (type == "approve") {
                if ($scope.selectedResourcesforApproval.length !== $scope.approveResourcesIds.length)
                    $scope.selectAllStudent.check = false;
                else
                    $scope.selectAllStudent.check = true;
            } else if (type == "complete") {
                if ($scope.selectedApprovedResources.length = $scope.approvedResourcesIds.length)
                    $scope.selectAllStudent.check = false;
                else
                    $scope.selectAllStudent.check = true;
            }
        }

        /*
         * Function to unselect all resources to submit for approval
         * 
         * @return : null
         */
        $scope.unselectAllResources = function (type) {
            if (type == "submit") {
                $scope.selectedResources = [];
            } else if (type == "approve") {
                $scope.selectedResourcesforApproval = [];
            } else if (type == "complete") {
                $scope.selectedApprovedResources = []
            }
        }


        $scope.gotoauthoringtool = () => {
            $state.go('authoringTool');
        }

        /*
         * To export teaching plan as PDF file
         * 
         * @return : null
         */

        $scope.exportAspagePDF = function () {
            if ($scope.teachingPlan) {
                let teachingPlanData = $scope.teachingPlan;

                /* html2canvas($("#myCanvas"),{
                 onrendered: function(canvas) {  
                 var imgData = canvas.toDataURL(
                 'image/png');          
                 var doc = new jsPDF('landscape');  
                 var width  = canvas.width;
                 var height  = canvas.height;
                 console.log(width+"  "+height)
                 doc.addImage(imgData, 'PNG',0, 5, width, height);
                 doc.save(teachingPlanData.title + ".pdf"); 
                 }
                 }); */
                var quotes = document.getElementById('myCanvas');
                html2canvas(quotes, {
                    onrendered: function (canvas) {
                        //! MAKE YOUR PDF
                        var pdf = new jsPDF('p', 'pt', 'letter');
                        for (var i = 0; i <= quotes.clientHeight / 1080; i++) {
                            //! This is all just html2canvas stuff
                            var srcImg = canvas;
                            var sX = 0;
                            var sY = 1080 * i; // start 980 pixels down for every new page
                            var sWidth = 900;
                            var sHeight = 1080;
                            var dX = 0;
                            var dY = 0;
                            var dWidth = 900;
                            var dHeight = 1080;
                            window.onePageCanvas = document.createElement("canvas");
                            onePageCanvas.setAttribute('width', 900);
                            onePageCanvas.setAttribute('height', 1080);
                            var ctx = onePageCanvas.getContext('2d');
                            ctx.drawImage(srcImg, sX, sY, sWidth, sHeight, dX, dY, dWidth, dHeight);
                            var canvasDataURL = onePageCanvas.toDataURL("image/png", 1.0);

                            var width = onePageCanvas.width;
                            var height = onePageCanvas.clientHeight;
                            if (i > 0) {
                                pdf.addPage(612, 791); //8.5" x 11" in pts (in*72)
                            }
                            pdf.setPage(i + 1);
                            //! now we add content to that page!
                            pdf.addImage(canvasDataURL, 'PNG', 20, 40, (width * .62), (height * .62));

                        }
                        //! after the for loop is finished running, we save the pdf.
                        pdf.save(teachingPlanData.title + ".pdf");
                    }
                });
            }
            /*if ($scope.viewTeachingPlan.teachingPlanDetails) {
              let teachingPlanData = $scope.viewTeachingPlan.teachingPlanDetails;
              kendo.drawing
              .drawDOM("#myCanvas", 
              { 
              paperSize: "A4",
              margin: { top: "1cm", bottom: "1cm" },
              scale: 0.8,
              height: 500
              })
              .then(function(group){
              kendo.drawing.pdf.saveAs(group, teachingPlanData.title + ".pdf")
              });
            }*/
        }


        $scope.exportAsPDF = function () {
            if ($scope.viewTeachingPlan.teachingPlanDetails) {
                let teachingPlanData = $scope.viewTeachingPlan.teachingPlanDetails
                let pdfContent = []

                let header = {
                    style: 'pdfheader',
                    table: {
                        widths: ['*', '*', '*'],
                        body: [
                            [{
                                width: 70,
                                height: 70,
                                image: $scope.imgurl1,
                                rowSpan: '3'
                            }, {
                                text: $scope.schoolHeader.schoolName,
                                fontSize: 18,
                                bold: true,
                                alignment: 'center'
                            }, {}],
                            [{}, {
                                alignment: 'center',
                                fontSize: 13,
                                text: 'Academic Year : ' + $scope.schoolHeader.academicYear
                            }, {}],
                            [{}, {
                                alignment: 'center',
                                fontSize: 14,
                                text: authoring.session + '/' + authoring.curriculum + '/' + authoring.class + '/' + authoring.batch
                            }, {}]
                        ]
                    },
                    layout: 'noBorders'
                }
                pdfContent.push(header)

                let teachingPlanHeader = {
                    style: 'tpheader',
                    table: {
                        widths: ['*', '*', 'auto'],
                        body: [
                            [{
                                text: 'Theme : ' + teachingPlanData.theme_title,
                                style: 'tpheadertext'
                            }, {
                                text: 'Teaching Plan : ' + teachingPlanData.title,
                                style: 'tpheadertext'
                            }, {}]
                        ]
                    },
                    layout: 'noBorders'
                }
                pdfContent.push(teachingPlanHeader)

                let dateHeader = {
                    style: 'dateheader',
                    table: {
                        widths: ['*'],
                        body: [
                            [{
                                text: 'Start Date : ' + teachingPlanData.start_date.getDate() + '.' + teachingPlanData.start_date.getMonth() + '.' + teachingPlanData.start_date.getFullYear() + '    End Date : ' + teachingPlanData.end_date.getDate() + '.' + teachingPlanData.end_date.getMonth() + '.' + teachingPlanData.end_date.getFullYear(),
                                fontSize: 11,
                                color: '#006cbb',
                                margin: [5, 5, 5, 5]
                            }]
                        ]
                    },
                    layout: 'noBorders'
                }
                pdfContent.push(dateHeader)

                if (teachingPlanData.objectives && teachingPlanData.objectives.length > 0) {
                    let tableBody = [
                        [{
                            width: teachingPlanImgSize,
                            height: teachingPlanImgSize,
                            image: $scope.teachingPlanImg,
                            fillColor: '#f14e5a'
                        }, {
                            text: 'OBJECTIVES',
                            style: 'tpbodyhead'
                        }]
                    ]
                    _.each(teachingPlanData.objectives, function (data) {
                        tableBody.push([{
                            width: rightArrowIconSize,
                            height: rightArrowIconSize,
                            image: $scope.rightArrow
                        }, {
                            text: data,
                            style: 'tpbodydata'
                        }])
                    })
                    let tpBody = {
                        style: 'tpbody',
                        table: {
                            widths: ['auto', '*'],
                            body: tableBody
                        },
                        dontBreakRows: true,
                        layout: {
                            hLineColor: function (i, node) {
                                return (i === 0 || i === node.table.body.length) ? '#dfdfdf' : 'white';
                            },
                            vLineColor: function (i, node) {
                                return (i === 0 || i === node.table.widths.length) ? '#dfdfdf' : 'white';
                            },
                        }
                    }
                    pdfContent.push(tpBody)
                }

                if (teachingPlanData.knowledge_required && teachingPlanData.knowledge_required.length > 0) {
                    let tableBody = [
                        [{
                            width: teachingPlanImgSize,
                            height: teachingPlanImgSize,
                            image: $scope.teachingPlanImg,
                            fillColor: '#00b4be'
                        }, {
                            text: 'REQUIRED KNOWLEDGE',
                            style: 'tpbodyhead'
                        }]
                    ]
                    _.each(teachingPlanData.knowledge_required, function (data) {
                        tableBody.push([{
                            width: rightArrowIconSize,
                            height: rightArrowIconSize,
                            image: $scope.rightArrow
                        }, {
                            text: data,
                            style: 'tpbodydata'
                        }])
                    })
                    let tpBody = {
                        style: 'tpbody',
                        table: {
                            widths: ['auto', '*'],
                            body: tableBody
                        },
                        dontBreakRows: true,
                        layout: {
                            hLineColor: function (i, node) {
                                return (i === 0 || i === node.table.body.length) ? '#dfdfdf' : 'white';
                            },
                            vLineColor: function (i, node) {
                                return (i === 0 || i === node.table.widths.length) ? '#dfdfdf' : 'white';
                            },
                        }
                    }
                    pdfContent.push(tpBody)
                }

                if (teachingPlanData.learning_materials && teachingPlanData.learning_materials.length > 0) {
                    let tableBody = [
                        [{
                            width: teachingPlanImgSize,
                            height: teachingPlanImgSize,
                            image: $scope.teachingPlanImg,
                            fillColor: '#fbbc48'
                        }, {
                            text: 'REQUIRED LEARNING MATERIALS',
                            style: 'tpbodyhead'
                        }]
                    ]
                    _.each(teachingPlanData.learning_materials, function (data) {
                        tableBody.push([{
                            width: rightArrowIconSize,
                            height: rightArrowIconSize,
                            image: $scope.rightArrow
                        }, {
                            text: data,
                            style: 'tpbodydata'
                        }])
                    })
                    let tpBody = {
                        style: 'tpbody',
                        table: {
                            widths: ['auto', '*'],
                            body: tableBody
                        },
                        dontBreakRows: true,
                        layout: {
                            hLineColor: function (i, node) {
                                return (i === 0 || i === node.table.body.length) ? '#dfdfdf' : 'white';
                            },
                            vLineColor: function (i, node) {
                                return (i === 0 || i === node.table.widths.length) ? '#dfdfdf' : 'white';
                            },
                        }
                    }
                    pdfContent.push(tpBody)
                }

                if (teachingPlanData.teaching_methodology && teachingPlanData.teaching_methodology.length > 0) {
                    let tableBody = [
                        [{
                            width: teachingPlanImgSize,
                            height: teachingPlanImgSize,
                            image: $scope.teachingPlanImg,
                            fillColor: '#00b6ef'
                        }, {
                            text: 'REQUIRED TEACHING METHODOLOGY',
                            style: 'tpbodyhead'
                        }]
                    ]
                    _.each(teachingPlanData.teaching_methodology, function (data) {
                        tableBody.push([{
                            width: rightArrowIconSize,
                            height: rightArrowIconSize,
                            image: $scope.rightArrow
                        }, {
                            text: data,
                            style: 'tpbodydata'
                        }])
                    })
                    let tpBody = {
                        style: 'tpbody',
                        table: {
                            widths: ['auto', '*'],
                            body: tableBody
                        },
                        dontBreakRows: true,
                        layout: {
                            hLineColor: function (i, node) {
                                return (i === 0 || i === node.table.body.length) ? '#dfdfdf' : 'white';
                            },
                            vLineColor: function (i, node) {
                                return (i === 0 || i === node.table.widths.length) ? '#dfdfdf' : 'white';
                            },
                        }
                    }
                    pdfContent.push(tpBody)
                }

                if (teachingPlanData.life_skills && teachingPlanData.life_skills.length > 0) {
                    let tableBody = [
                        [{
                            width: teachingPlanImgSize,
                            height: teachingPlanImgSize,
                            image: $scope.teachingPlanImg,
                            fillColor: '#00ba9c'
                        }, {
                            text: 'REQUIRED LIFE SKILLS',
                            style: 'tpbodyhead'
                        }]
                    ]
                    _.each(teachingPlanData.life_skills, function (data) {
                        tableBody.push([{
                            width: rightArrowIconSize,
                            height: rightArrowIconSize,
                            image: $scope.rightArrow
                        }, {
                            text: data,
                            style: 'tpbodydata'
                        }])
                    })
                    let tpBody = {
                        style: 'tpbody',
                        table: {
                            widths: ['auto', '*'],
                            body: tableBody
                        },
                        dontBreakRows: true,
                        layout: {
                            hLineColor: function (i, node) {
                                return (i === 0 || i === node.table.body.length) ? '#dfdfdf' : 'white';
                            },
                            vLineColor: function (i, node) {
                                return (i === 0 || i === node.table.widths.length) ? '#dfdfdf' : 'white';
                            },
                        }
                    }
                    pdfContent.push(tpBody)
                }

                if (teachingPlanData.conclusion && teachingPlanData.conclusion.length > 0) {
                    let tableBody = [
                        [{
                            width: teachingPlanImgSize,
                            height: teachingPlanImgSize,
                            image: $scope.teachingPlanImg,
                            fillColor: '#f14e5a'
                        }, {
                            text: 'REQUIRED CONCLUSION',
                            style: 'tpbodyhead'
                        }]
                    ]
                    _.each(teachingPlanData.conclusion, function (data) {
                        tableBody.push([{
                            width: rightArrowIconSize,
                            height: rightArrowIconSize,
                            image: $scope.rightArrow
                        }, {
                            text: data,
                            style: 'tpbodydata'
                        }])
                    })
                    let tpBody = {
                        style: 'tpbody',
                        table: {
                            widths: ['auto', '*'],
                            body: tableBody
                        },
                        dontBreakRows: true,
                        layout: {
                            hLineColor: function (i, node) {
                                return (i === 0 || i === node.table.body.length) ? '#dfdfdf' : 'white';
                            },
                            vLineColor: function (i, node) {
                                return (i === 0 || i === node.table.widths.length) ? '#dfdfdf' : 'white';
                            },
                        }
                    }
                    pdfContent.push(tpBody)
                }

                if (teachingPlanData.formative_assessment && teachingPlanData.formative_assessment.length > 0) {
                    let tableBody = [
                        [{
                            width: teachingPlanImgSize,
                            height: teachingPlanImgSize,
                            image: $scope.teachingPlanImg,
                            fillColor: '#00b4be'
                        }, {
                            text: 'REQUIRED FORMATIVE ASSESSMENT',
                            style: 'tpbodyhead'
                        }]
                    ]
                    _.each(teachingPlanData.formative_assessment, function (data) {
                        tableBody.push([{
                            width: rightArrowIconSize,
                            height: rightArrowIconSize,
                            image: $scope.rightArrow
                        }, {
                            text: data,
                            style: 'tpbodydata'
                        }])
                    })
                    let tpBody = {
                        style: 'tpbody',
                        table: {
                            widths: ['auto', '*'],
                            body: tableBody
                        },
                        dontBreakRows: true,
                        layout: {
                            hLineColor: function (i, node) {
                                return (i === 0 || i === node.table.body.length) ? '#dfdfdf' : 'white';
                            },
                            vLineColor: function (i, node) {
                                return (i === 0 || i === node.table.widths.length) ? '#dfdfdf' : 'white';
                            },
                        }
                    }
                    pdfContent.push(tpBody)
                }

                if (teachingPlanData.resources_including_ICT && teachingPlanData.resources_including_ICT.length > 0) {
                    let tableBody = [
                        [{
                            width: teachingPlanImgSize,
                            height: teachingPlanImgSize,
                            image: $scope.teachingPlanImg,
                            fillColor: '#fbbc48'
                        }, {
                            text: 'REQUIRED RESOURCES INCLUDING ICT',
                            style: 'tpbodyhead'
                        }]
                    ]
                    _.each(teachingPlanData.resources_including_ICT, function (data) {
                        tableBody.push([{
                            width: rightArrowIconSize,
                            height: rightArrowIconSize,
                            image: $scope.rightArrow
                        }, {
                            text: data,
                            style: 'tpbodydata'
                        }])
                    })
                    let tpBody = {
                        style: 'tpbody',
                        table: {
                            widths: ['auto', '*'],
                            body: tableBody
                        },
                        dontBreakRows: true,
                        layout: {
                            hLineColor: function (i, node) {
                                return (i === 0 || i === node.table.body.length) ? '#dfdfdf' : 'white';
                            },
                            vLineColor: function (i, node) {
                                return (i === 0 || i === node.table.widths.length) ? '#dfdfdf' : 'white';
                            },
                        }
                    }
                    pdfContent.push(tpBody)
                }

                if (teachingPlanData.flow_of_lesson && Object.keys(teachingPlanData.flow_of_lesson).length > 0) {
                    let tableHead = [
                        [{
                            width: teachingPlanImgSize,
                            height: teachingPlanImgSize,
                            image: $scope.teachingPlanImg,
                            fillColor: '#00b6ef'
                        }, {
                            text: 'FLOW OF TEACHING PLAN',
                            style: 'tpbodyhead'
                        }]
                    ]
                    let tpHead = {
                        pageBreak: 'before',
                        style: 'tpnewhead',
                        table: {
                            widths: ['auto', '*'],
                            body: tableHead
                        },
                        dontBreakRows: true,
                        layout: {
                            hLineColor: function (i, node) {
                                return (i === 0 || i === node.table.body.length) ? '#dfdfdf' : 'white';
                            },
                            vLineColor: function (i, node) {
                                return (i === 0 || i === node.table.widths.length) ? '#dfdfdf' : 'white';
                            },
                        }
                    }
                    pdfContent.push(tpHead)
                    let tableBody = []
                    let tableBodyKey = []
                    let tableBodyData = []
                    _.each(teachingPlanData.flow_of_lesson, function (data, key) {
                        tableBodyKey.push({
                            text: $scope.keyReplaceCase(key),
                            style: 'tpbodyheaddata'
                        })
                        tableBodyData.push({
                            text: data,
                            style: 'tpnewbodydata'
                        })
                    })
                    let dataLength = Math.ceil(tableBodyKey.length / 2)
                    for (let i = 0; i < dataLength; i++) {
                        let keys = []
                        let values = []
                        tableBodyKey[2 * i] != undefined ? keys.push(tableBodyKey[2 * i]) : keys.push({})
                        tableBodyKey[2 * i + 1] != undefined ? keys.push(tableBodyKey[2 * i + 1]) : keys.push({})
                        tableBody.push(keys)
                        tableBodyData[2 * i] != undefined ? values.push(tableBodyData[2 * i]) : values.push({})
                        tableBodyData[2 * i + 1] != undefined ? values.push(tableBodyData[2 * i + 1]) : values.push({})
                        tableBody.push(values)
                    }
                    let tpBody = {
                        style: 'tpnewbody',
                        table: {
                            widths: ['*', '*'],
                            body: tableBody
                        },
                        dontBreakRows: true,
                        layout: {
                            hLineColor: function (i, node) {
                                return (i === 0 || i === node.table.body.length) ? '#dfdfdf' : 'white';
                            },
                            vLineColor: function (i, node) {
                                return (i === 0 || i === node.table.widths.length) ? '#dfdfdf' : 'white';
                            },
                        }
                    }
                    pdfContent.push(tpBody)
                }

                if (teachingPlanData.remedial_teaching_plan && Object.keys(teachingPlanData.remedial_teaching_plan).length > 0) {
                    let tableHead = [
                        [{
                            width: teachingPlanImgSize,
                            height: teachingPlanImgSize,
                            image: $scope.teachingPlanImg,
                            fillColor: '#00ba9c'
                        }, {
                            text: 'REMEDIAL TEACHING PLAN',
                            style: 'tpbodyhead'
                        }]
                    ]
                    let tpHead = {
                        style: 'tpnewhead',
                        table: {
                            widths: ['auto', '*'],
                            body: tableHead
                        },
                        dontBreakRows: true,
                        layout: {
                            hLineColor: function (i, node) {
                                return (i === 0 || i === node.table.body.length) ? '#dfdfdf' : 'white';
                            },
                            vLineColor: function (i, node) {
                                return (i === 0 || i === node.table.widths.length) ? '#dfdfdf' : 'white';
                            },
                        }
                    }
                    pdfContent.push(tpHead)
                    let tableBody = []
                    let tableBodyKey = []
                    let tableBodyData = []
                    _.each(teachingPlanData.remedial_teaching_plan, function (data, key) {
                        tableBodyKey.push({
                            text: $scope.keyReplaceCase(key),
                            style: 'tpbodyheaddata'
                        })
                        tableBodyData.push({
                            text: data,
                            style: 'tpnewbodydata'
                        })
                    })
                    let dataLength = Math.ceil(tableBodyKey.length / 2)
                    for (let i = 0; i < dataLength; i++) {
                        let keys = []
                        let values = []
                        tableBodyKey[2 * i] != undefined ? keys.push(tableBodyKey[2 * i]) : keys.push({})
                        tableBodyKey[2 * i + 1] != undefined ? keys.push(tableBodyKey[2 * i + 1]) : keys.push({})
                        tableBody.push(keys)
                        tableBodyData[2 * i] != undefined ? values.push(tableBodyData[2 * i]) : values.push({})
                        tableBodyData[2 * i + 1] != undefined ? values.push(tableBodyData[2 * i + 1]) : values.push({})
                        tableBody.push(values)
                    }
                    let tpBody = {
                        style: 'tpnewbody',
                        table: {
                            widths: ['*', '*'],
                            body: tableBody
                        },
                        dontBreakRows: true,
                        layout: {
                            hLineColor: function (i, node) {
                                return (i === 0 || i === node.table.body.length) ? '#dfdfdf' : 'white';
                            },
                            vLineColor: function (i, node) {
                                return (i === 0 || i === node.table.widths.length) ? '#dfdfdf' : 'white';
                            },
                        }
                    }
                    pdfContent.push(tpBody)
                }

                if (teachingPlanData.resources && teachingPlanData.resources.length > 0) {
                    let tableBody = [
                        [{
                            width: teachingPlanImgSize,
                            height: teachingPlanImgSize,
                            image: $scope.teachingPlanImg,
                            fillColor: '#f14e5a'
                        }, {
                            text: 'RESOURCES REQUIRED',
                            style: 'tpbodyhead'
                        }]
                    ]
                    _.each(teachingPlanData.resources, function (data) {
                        tableBody.push([{
                            width: rightArrowIconSize,
                            height: rightArrowIconSize,
                            image: $scope.rightArrow
                        }, {
                            text: data.title,
                            style: 'tpbodydata'
                        }])
                    })
                    let tpBody = {
                        style: 'tpbody',
                        table: {
                            widths: ['auto', '*'],
                            body: tableBody
                        },
                        dontBreakRows: true,
                        layout: {
                            hLineColor: function (i, node) {
                                return (i === 0 || i === node.table.body.length) ? '#dfdfdf' : 'white';
                            },
                            vLineColor: function (i, node) {
                                return (i === 0 || i === node.table.widths.length) ? '#dfdfdf' : 'white';
                            },
                        }
                    }
                    pdfContent.push(tpBody)
                }

                var docDefinition = {
                    footer: function (currentPage, pageCount) {
                        return {
                            text: currentPage.toString() + ' of ' + pageCount,
                            alignment: 'center'
                        }
                    },
                    content: pdfContent,
                    styles: {
                        pdfheader: {
                            margin: [0, 5, 0, 15],
                        },
                        tpheader: {
                            margin: [0, 0, 0, 10],
                            fillColor: '#00ba9c'
                        },
                        tpheadertext: {
                            margin: [5, 10, 5, 10],
                            color: 'white',
                            bold: true,
                            fontSize: 13
                        },
                        dateheader: {
                            margin: [0, 0, 0, 10],
                            fillColor: '#dfdfdf'
                        },
                        tpbody: {
                            margin: [0, 0, 0, 10],
                        },
                        tpbodyhead: {
                            margin: [5, 5, 0, 0],
                            color: '#006cbb',
                            fillColor: '#dfdfdf',
                            fontSize: 13,
                            bold: true
                        },
                        tpbodydata: {
                            margin: [0, 3, 0, 0],
                            fontSize: 12
                        },
                        tpnewhead: {
                            margin: [0, 0, 0, 0],
                            color: '#006cbb',
                            fillColor: '#dfdfdf',
                            fontSize: 13,
                            bold: true
                        },
                        tpnewbody: {
                            margin: [0, 0, 0, 10]
                        },
                        tpbodyheaddata: {
                            margin: [5, 5, 0, 0],
                            color: '#006cbb',
                            fontSize: 12,
                            bold: true
                        },
                        tpnewbodydata: {
                            margin: [5, 0, 0, 5]
                        }
                    }
                }
                pdfMake.createPdf(docDefinition).download(teachingPlanData.title + '.pdf');
                try {
                    let tincanData = {
                        actor: {
                            "mbox": "mailto:" + Meteor.user().username,
                            "account": {
                                "name": Meteor.user().name,
                                "homePage": SITE_URL
                            },
                            "objectType": "Agent"
                        },
                        verb: {
                            id: SITE_URL + "expapi/verbs/interacted",
                            display: {
                                "en-US": "clicked"
                            }
                        },
                        object: {
                            id: window.location.href,
                            definition: {
                                type: SITE_URL + "type/teachingplan",
                                name: {
                                    "en-US": "Export as PDF"
                                },
                                description: {
                                    "en-US": "Export as PDF button is clicked"
                                },
                                "objectType": "Activity"
                            }
                        }
                    }
                    TinCanApiService.sendTincanApiRequest(tincanData)
                } catch (ex) {

                }
            }
        }

        /*
         * To replace '_' and convert each word first letter as Upper case letter
         * 
         * @data : String - Data to be replace
         * 
         * @return : String - Given data without Underscore
         */
        $scope.keyReplaceCase = function (data) {
            let str = data.replace(/_/g, ' ');
            return str.replace(/\w\S*/g, function (txt) {
                return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
            })
        }

        $scope.exportToClassroom = function (name) {
            var topicName = name ? name : $scope.teachingPlan.title;
            var reqObj = {
                tp_id: $scope.teachingPlan._id,
                tp_name: topicName,
                course_id: $scope.classroomDetails._id,
                teacher_email: localStorageService.get('username'),
                school_id: authoring.school_id
            }
            $scope.isLoading = true;
            authService.callAPI(GOOGLE_CLASSROOM_CONSTANTS.API_EXPORT_TO_GOOGLE_CLASSROOM, 'POST', reqObj, function (response) {
                if (response.result && response.result.data) {
                    try {
                        $scope.isLoading = false;
                        toastr.success('Teaching Plan exported successfully');
                    } catch (ex) {
                        $scope.isLoading = false;
                        console.log(ex);
                    }
                } else if (response.error && response.error.error && response.error.error.errors) {
                    if (response.error.error.errors[0].reason === 'alreadyExists') {
                        var confirm = $mdDialog.confirm()
                            .title('Already Exists!')
                            .textContent('A topic with the same Teaching Plan name already exists on your Google Classroom course. Do you want to make a copy?')
                            .ariaLabel('Lucky day')
                            .ok('Yes')
                            .cancel('No');
                        $mdDialog.show(confirm).then(function () {
                            let newTopicName = $scope.teachingPlan.title + '_copy_' + +new Date();
                            $scope.exportToClassroom(newTopicName);
                        }, function () {
                            $scope.isLoading = false;
                        });
                    } else {
                        $scope.isLoading = false;
                        toastr.error('Network Error. Please try later');
                    }
                } else {
                    $scope.isLoading = false;
                    toastr.error('Network Error. Please try later');
                }
                _.defer(function () {
                    $scope.$apply();
                });
            });
        }
    }
}

export default ViewTeachingPlanController;



// WEBPACK FOOTER //
// ./src/app/authoring-tool/teachingPlan/controllers/viewTeachingPlanController.js